export type WebVisibilityValueInputType = 'list' | 'text' | 'checkbox';
export type WebVisibilityRuleKind = 'rate_field' | 'custom_sql';

export interface WebVisibilityRule {
    id?: string;
    label: string;
    field_key: string;
    rule_kind?: WebVisibilityRuleKind;
    sql_expression?: string | null;
    condition_sql?: string | null;
    autocomplete_field?: string | null;
    operator?: string | null;
    value_input_type?: WebVisibilityValueInputType | null;
    values?: string[] | null;
    is_active: boolean;
}

export interface WebVisibilityEditorOptionsResponse {
    operators: { value: string; label: string }[];
    value_input_types: { value: WebVisibilityValueInputType; label: string }[];
}

export function isMultiValueInput(
    valueInputType: WebVisibilityValueInputType | null | undefined
): boolean {
    return valueInputType === 'list';
}

/** Default value input type when the user picks an operator. */
export function valueInputTypeForOperator(
    operator: string | null | undefined
): WebVisibilityValueInputType {
    switch (operator) {
        case 'in':
        case 'not_in':
            return 'list';
        case 'ilike':
        case 'not_ilike':
        case 'equal':
        case 'not_equal':
            return 'text';
        default:
            return 'text';
    }
}

export function usesCustomSql(rule: WebVisibilityRule): boolean {
    return rule.rule_kind === 'custom_sql' || !!(rule.condition_sql?.trim());
}
